export default "__VITE_ASSET__BnAxqqfv__"